import { Reveal } from "./Reveal";
import { WAITLIST_URL } from "./data";

export const FinalCTA = () => (
    <section
        id="waitlist"
        data-testid="final-cta-section"
        className="border-t border-[#262422] px-5 py-28 sm:px-8 sm:py-44"
    >
        <div className="mx-auto max-w-[1500px]">
            <Reveal>
                <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#C7B7FF]">
                    The early waitlist
                </p>
                <h2 className="mt-8 max-w-4xl text-4xl font-bold leading-[1.06] tracking-tight text-[#F4F1EC] sm:text-6xl lg:text-7xl">
                    Find people you{" "}
                    <em className="font-serif2 font-normal italic text-[#C7B7FF]">actually</em>{" "}
                    want to know.
                </h2>
                <p className="mt-8 max-w-xl text-base leading-relaxed text-[#C9C5C0] sm:text-lg">
                    Discovery is still an early research project. Join the waitlist and help shape
                    what the first version becomes.
                </p>
                <div className="mt-10">
                    <a
                        href={WAITLIST_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="final-waitlist-btn"
                        className="cta-primary inline-block rounded-full bg-[#C7B7FF] px-8 py-4 text-base font-semibold text-[#0D0C0B] sm:text-lg"
                    >
                        Join the early waitlist <span className="cta-arrow">→</span>
                    </a>
                </div>
                <p className="mt-6 text-sm text-[#8A8580]">
                    No spam · Early research project · Help shape the first version
                </p>
                <p className="font-mono2 mt-10 text-xs uppercase tracking-[0.2em] text-[#C7B7FF]">
                    Less engagement. More connection.
                </p>
            </Reveal>
        </div>
    </section>
);
